<template>
  <div class="main-content" :style="mainContentViewHeight">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-input v-model="dataForm.searchKey" placeholder="请输入关键字" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      @selection-change="selectionChangeHandle"
      @row-dblclick="dbClickHandle"
      style="width: 100%;">
      <el-table-column
              fixed
              type="index"
              header-align="left"
              align="left"
              label="序号"
              width="60"
              :index="getRowsIndex"
      >
      </el-table-column>
      <el-table-column
        prop="appName"
        fixed
        header-align="center"
        align="left"
        label="名称">
      </el-table-column>
      <el-table-column
        prop="state"
        header-align="center"
        align="center"
        label="发布状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state == 0" size="small" type="danger">禁用</el-tag>
          <el-tag v-else size="small">已发布</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="innerNetInfo"
        header-align="center"
        align="center"
        label="内网访问地址">
      </el-table-column>
      <el-table-column
        prop="webInfo"
        header-align="center"
        align="center"
        width="180"
        label="外网访问地址">
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="150"
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showDetailHandle(scope.row.id,scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <!-- 弹窗, 新增 -->
    <add-form v-if="addVisible" ref="addForm" @refreshDataList="getDataList"></add-form>
  </div>
</template>

<script>
  import AddForm from './app-add'
  export default {
    props: ['mainContentViewHeight'],
    data () {
      return {
        dataForm: {
          searchKey: ''
        },
        dataList: [],
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        dataListLoading: false,
        dataListSelections: [],
        addVisible: false
      }
    },
    components: {
      AddForm
    },
    activated () {
      this.getDataList()
    },
    created(){
    },
    computed: {
      appInfo: {
        get() {
          return this.$store.state.common.appInfo
        },
        set(val) {
          this.$store.commit('common/updateAppInfo', val)
        }
      },
    },
    methods: {
      getRowsIndex(index) {
        return (this.pageIndex - 1) * this.pageSize + index + 1
      },
      getDataList () {
        this.dataListLoading = true
        this.$http.post('/auth/application/search_app_list',{
          'page': this.pageIndex,
          'rows': this.pageSize,
          'searchKey':this.dataForm.searchKey,
          'filter':{}
        }).then(({data}) => {
          if (data ) {
            this.dataList = data.rows
            this.totalPage = data.totalItemCount
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.dataListLoading = false
        })
      },
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      // 多选
      selectionChangeHandle (val) {
        this.dataListSelections = val
      },
      // 新增 / 修改
      addHandle ( ) {
        this.addVisible = true
        this.$nextTick(() => {
          this.$refs.addForm.init( )
        })
      },
      showDetailHandle(id,item){
        this.appInfo=item
        this.updateMenuType({code:1,id:item.id})
        this.tabsCloseOtherThenOpen('app-detail',{title:'应用信息查看',appId:id})
      },
      dbClickHandle(data,args){
        this.showDetailHandle(data.id,data)
      },
      // 删除
      deleteHandle (id) {
        this.$confirm(`确定要删除该数据?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http({
            url: this.$http.adornUrl('/auth/application/deleteSysApp?ids=' + id),
            method: 'delete',
          }).then(({data}) => {
            if (data && data.code === '1') {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }).catch(() => {})
      }
    }
  }
</script>
